function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { config } from '../../configuration';
import styles from './Button.module.css';

/** @param {string} str */
const dashToCamelCase = str => str.replace(/-([a-z])/g, g => g[1].toUpperCase());

/**
 * @typedef {object} ButtonProps
 * @property {("primary"|"secondary"|"tertiary"|"tertiary-filled")} props.buttonType - primary = green, secondary - white, tertiary = text-only, tertiary-filled = pale green
 * @property {React.ReactNode} props.children - react children argument
 * @property {string=} props.className - classes to add to button
 * @property {boolean=} props.dark - dark mode for button
 * @property {boolean=} props.floating - "floating" styles for button positioned fixed over content
 * @property {boolean=} props.loading - loading state, show the spinner
 */

/**
 * @param {ButtonProps & React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>} props
 */
export default function Button({
  buttonType,
  children,
  className = '',
  dark = false,
  disabled = false,
  floating = false,
  loading = false,
  ...otherProps
}) {
  const classes = [styles[`${dashToCamelCase(buttonType)}Button`]];
  if (dark) {
    classes.push(styles.dark);
  }
  if (floating) {
    if (buttonType === 'tertiary') {
      throw new Error('Floating buttons cannot be of type "tertiary"');
    }
    classes.push(styles.floating);
  }
  if (className.length) {
    classes.push(...className.split(' '));
  }
  if (disabled) {
    classes.push(styles.disabled);
  }
  if (config.isTouchScreen) {
    classes.push(styles.touchScreen);
  }
  const classesString = classes.join(' ');
  return /*#__PURE__*/React.createElement("button", _extends({}, otherProps, {
    className: classesString,
    disabled: disabled
  }), loading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.loaderWrapper
  }, /*#__PURE__*/React.createElement("svg", {
    className: `${styles.loader}`,
    viewBox: "0 0 66 66",
    "aria-hidden": "true",
    focusable: "false",
    role: "presentation",
    width: "30",
    height: "30"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "33",
    cy: "33",
    r: "30"
  }))), /*#__PURE__*/React.createElement("span", null, children)) : children);
}